import appConfig from 'app-config';
import { withLocaleStaticPaths, withTranslations } from 'src/i18n/static-generation';
import MatchView from 'src/views/Match';
import VividiLandingView from 'src/views/VividiLanding';
export const getStaticPaths = withLocaleStaticPaths();
export const getStaticProps = withTranslations(() => ({
  props: {
    canonical: true,
    metas: [{
      property: 'og:title',
      content: 'OG_TITLE',
      key: 'og:title'
    }, {
      property: 'og:description',
      content: 'OG_DESC',
      key: 'og:description'
    }, {
      name: 'description',
      content: 'OG_DESC',
      key: 'description'
    }, {
      property: 'og:image',
      content: `/${appConfig.serviceCode}/images/og/openGraph.png`,
      key: 'og:image'
    }]
  }
}), {
  xDefaultRouteFn: () => ({
    pathname: '/'
  })
});
const LocalizedIndexPage = () => appConfig.serviceCode === 'vividi' ? <VividiLandingView /> : <MatchView />;
export default LocalizedIndexPage;